import { Box, 
  Grid, 
  Button,
  IconButton,
 } 
  from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetUserCountries,
  GetCustomersToRename_Pagination,
  UpdateCustomerData,
  setState,
  GetCustomerCount,
} from "./functionalAdminSlice";
import { DataGridPro } from "@mui/x-data-grid-pro";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import MessageForFunctionalAdmin from "./MessageForFunctionalAdmin";
import CloseIcon from '@mui/icons-material/Close';

export default function CustomerRename() {

  debugger;

  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  const functionAdmin = useSelector((state) => state.functionAdmin);
  const {
    isLoading,
    countries,
    selectedCountry,
    selectedCountryID,
    getSKUData,
    getCustomerRenameData,
    getCustomerGroupRefData,
    customerCount,
    clearCustomerRename
  } = functionAdmin;

  const loginState = useSelector((store) => store.login);
  const { globalSelectedCountryName,globalSelectedCountryID,} = loginState


  const [open, setOpen] = useState(false);

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: 0,
  });
  const [PreviouspaginationModel, setPreviouspaginationModel] = useState({
    pageSize: 100,
    page: 0,
  });

  const [updateCustomerRow, setUpdateCustomerRow] = useState({
    customerID: "",
    clientCustomerCode: "",
    countryName: "",
    customerName: "",
  });

  //console.log("PageSize - ", paginationModel.pageSize);
  //console.log("PageIndex - ", paginationModel.page);

  const columns = [
    {
      field: "clientCustomerCode",
      headerName: "Client Customer Code",
      flex: 1,
      renderCell: (params) => (
        <div title={params.row.pName} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {params.value}
        </div>
      )
    },
    {
      field: "countryName",
      headerName: "Country Name",
      flex: 0.6,
    },

    {
      field: "customerName",
      headerName: "Customer Name",
      flex: 1.8,
      renderCell: (params) => (
        <div title={params.row.pName} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {params.value}
        </div>
      )
    },
    {
      field: "edit",
      headerName: "Edit",
      flex: 0.4,
      renderCell: (params) => {
        return (
          <EditIcon
            sx={{color:'#000000', 
              cursor:'pointer',
              '&:hover':{
              color:'#AD2A1C'
           }}}
            variant="contained"
            onClick={(event) => handleEdit(params)}
          />
        );
      },
    },
  ];

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (countries.length <= 0) {
      dispatch(GetUserCountries({ method: "Get" }));
    }
  }, [searchText]);

  useEffect(() => {
    //dispatch(setState("selectedCountry", ""));
    //dispatch(setState("selectedCountryID", null));
    debugger;
    if(globalSelectedCountryName !==null && globalSelectedCountryName !== "" ){
      dispatch(setState("selectedCountry", globalSelectedCountryName));
      dispatch(setState("selectedCountryID", globalSelectedCountryID));
    }
    else{
      dispatch(setState("selectedCountry", ""));
      dispatch(setState("selectedCountryID", ""));
    }
    dispatch(setState("getCustomerRenameData", []));
    dispatch(setState("customerCount", 0));
    dispatch(setState("clearCustomerRename", false));
  }, []);

  const handleSearchText = (e) => {
    const value = e.target.value;
    setSearchText(value);
  };

  const handleEdit = (params) => {
    setOpen(true);
    setUpdateCustomerRow({
      customerID: params.row.customerID,
      clientCustomerCode: params.row.clientCustomerCode,
      countryName: params.row.countryName,
      customerName: params.row.customerName,
    });
  };

  const handleConfirm = () => {
    setOpen(false);
    let obj = {
      customerID: updateCustomerRow?.customerID,
      customerName: updateCustomerRow?.customerName,
      clientCustomerCode: updateCustomerRow?.clientCustomerCode,
      countryName: updateCustomerRow?.countryName,
    };

    let newObj = {
      countryID: selectedCountryID,
      customerName: searchText,
      pageIndex: paginationModel.page,
      pageSize: paginationModel.pageSize,
    };

    dispatch(UpdateCustomerData(obj)).then(() =>
      dispatch(GetCustomersToRename_Pagination(newObj))
    );
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCustomerUpdate = (event) => {
    let customerUpdatedObj = {
      ...updateCustomerRow,
      [event.target.name]: event.target.value,
    };
    setUpdateCustomerRow(customerUpdatedObj);
  };
  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  const handleDisplay = async () => {
      if (selectedCountryID === null || selectedCountryID === "" ) {
      showMessage("Please select a country", "info");
      return false;
    }
    //  /ProductGroup/GetSKUSwitchSearch?CountryID=150&ProductName=ABACAV/LAMIVUD&SKUType=0
    let obj = {
      countryID: selectedCountryID,
      customerName: searchText,
      pageIndex: paginationModel.page,
      pageSize: paginationModel.pageSize,
    };

    let newObj = {
      customerName: searchText,
      geoId: selectedCountryID,
    };
    
    dispatch(GetCustomerCount(newObj));
    if(selectedCountryID===0){
     dispatch(GetCustomersToRename_Pagination(obj));
     dispatch(setState("clearCustomerRename", true));
    }
  else{
    try {
      await dispatch(GetCustomersToRename_Pagination(obj));
      dispatch(setState("clearCustomerRename", true));
    } 
    catch (error) {
      console.error("Error fetching customers:", error);
    }
  }

  };

  const handleCountryChange = (e) => {
    dispatch(setState("clearCustomerRename", false));
    setPaginationModel({pageSize: 100,
      page: 0,});
    const name = e.target.value;
    //console.log(countries.find((country) => country.countryName === name));
    let countryID = 0;
   if (name !== "All"){
       countryID = countries.find(
        (country) => country.countryName === name
      ).countryID;
    }
    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  };

  useEffect(() => {
    if(selectedCountryID !== null  && selectedCountryID !== "" &&
      (PreviouspaginationModel.page != paginationModel.page || PreviouspaginationModel.pageSize != paginationModel.pageSize)){
      let obj = {
        countryID: selectedCountryID,
        customerName: searchText,
        pageIndex: paginationModel.page,
        pageSize: paginationModel.pageSize,
      };
      setPreviouspaginationModel(paginationModel);
      dispatch(GetCustomersToRename_Pagination(obj));
    }
  }, [paginationModel]);

  return (
    <Box mt={3}>
      <Box>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress />
        </Backdrop>
      </Box>
      <Box>
        <MessageForFunctionalAdmin />
      </Box>
      <Box mt={2}>
        <Grid
          container
          columns={12}
          alignItems="center"
          spacing={2}
          sx={{justifyContent:'flex-start'}}
        >
          <Grid item xs={12} sm={3} md={3}>
            <TextField
              variant="outlined"
              label="Country"
              select={countries.length > 0 ? true : false}
              //value={countries.length > 0 ? selectedCountry.countryName : ""}
              value={selectedCountry}
              onChange={handleCountryChange}
              fullWidth
              size="small"
              sx={{minWidth:"80px"}}
            >
              <MenuItem value={"All"}>{"All"}</MenuItem>
              {countries.length > 0
                ? countries.map((country, index) => {
                  return (
                    <MenuItem
                      key={country.countryID}
                      value={country.countryName}
                    >
                      {country.countryName}
                    </MenuItem>
                  );
                })
                : null}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={5} md={5}>
            <TextField
              variant="outlined"
              label="Search"
              value={searchText}
              onChange={handleSearchText}
              fullWidth
              size="small"
              sx={{minWidth:"150px"}}
            ></TextField>
          </Grid>

          <Grid item xs={12} sm={2} md={2}>
            <Box justifyContent="flex-start" display="flex">
              <Button
                variant="contained"
                onClick={handleDisplay}
                size="large"   
                sx={{
                  bgcolor: "darkred.light",
                  color: "white.main",
                  textTransform: "none",
                  fontWeight: "bold",
                  "&:hover": {
                    bgcolor: "darkred.main",
                    color: "white.main",
                  },
                }}          
              >
                Search
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {clearCustomerRename && (
      <Box
        mt={2}
        sx={{
          width: "100%",
          minHeight: "200px",
        }}
      >
        <DataGridPro
           sx={{
            "& .MuiDataGrid-columnHeaders":{
               backgroundColor:"grey.lighter"
            }
           }}
          style={{ maxHeight: "calc(100vh - 130px)" }}
          rows={getCustomerRenameData || []}
          columns={columns}
          getRowId={(row) => row?.clientCustomerCode}
          rowCount={customerCount}
          disableColumnMenu
          // initialState={{
          //   pagination: {
          // 	paginationModel: {
          // 	  pageSize: 5,
          // 	},
          //   },
          // }}
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={(newModel) => {
            setPaginationModel(newModel);
          }}
          pageSizeOptions={[20, 50, 100]}
          pagination
          //checkboxSelection
          disableRowSelectionOnClick
        />
      </Box>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth={"md"}
        sx={{ mx: 3 }}
      >
        <DialogTitle
          id="scroll-dialog-title"
          variant="subtitle1"
          sx={{ color: "darkred.main", fontSize: "16px" }}
        >
          Edit
          {/* <hr style={{
     border: ".25px solid #c6c6c6",
    }}/> */}
        </DialogTitle>
        <IconButton
          onClick={handleClose}
          sx={{
            position:'absolute',
            top:10,
            right:10,
            zIndex:1,
            color:'grey'
          }}
          >
            <CloseIcon/>
          </IconButton>

        <Grid container gap={2} className="colClass" sx={{ px: 3 }}>
          <Grid item xs={12}>
            {/* <Typography variant="h6">Customer ID</Typography> */}
            <TextField
              id="customerID"
              name="customerID"
              className="customerData"
              label="Customer ID"
              variant="outlined"
              disabled
              //onChange={(event) => handleCustomerUpdate(event)}
              defaultValue={updateCustomerRow?.customerID}
              sx={{ mb: 2 }}
            />
            <TextField
              id="clientCustomerCode"
              name="clientCustomerCode"
              className="customerData"
              label="Client Customer Code"
              variant="outlined"
              disabled
              //onChange={(event) => handleCustomerUpdate(event)}
              defaultValue={updateCustomerRow?.clientCustomerCode}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              id="countryName"
              name="countryName"
              className="customerData"
              label="Country Nmae"
              variant="outlined"
              disabled
              //onChange={(event) => handleCustomerUpdate(event)}
              defaultValue={updateCustomerRow?.countryName}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              id="customerName"
              name="customerName"
              className="customerData"
              label="Customer Nmae"
              variant="outlined"
              // InputLabelProps={{
              //     shrink: true,
              // }}
              onChange={(event) => handleCustomerUpdate(event)}
              defaultValue={updateCustomerRow?.customerName}
              sx={{ mb: 2 }}
            />
          </Grid>
        </Grid>
        <DialogActions sx={{ mb: 2 }}>
          <Button onClick={handleClose} variant="outlined"
                         sx={{ 
                          color: "darkred.light",
                          bgcolor: "grey.lighter",
                          border:"none",
                          "&:hover": {
                            bgcolor: "darkred.main",
                            color: "white.main",
                            border:"none",
                          },
                         }}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={!isRestrictedAccess}
            variant="contained"
            sx={{
              mr:2,
              bgcolor: "darkred.light",
              color: "white.main",
              textTransform: "none",
              fontWeight: "bold",
              "&:hover": {
                bgcolor: "darkred.main",
                color: "white.main",
              },
            }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
